import React from "react";
import dayjs from "dayjs";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import BackArrow2 from "../../components/BackArrow2";
import IpoForm, { ipoCreateStatusOptions, stockSourceOptions } from "./IpoForm";
import { buildIpoPayload } from "./buildIpoPayload";
import { createIpo } from "../../store/actions/ipos/createIpo";
import { createIpoSchema } from "../../Helper/validationSchemas";
import { currencyStockOptions } from "../Stocks/StockForm";

function CreateIpo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state?.ipos?.createPending) || false;

  const form = useFormik({
    initialValues: {
      stock_source: stockSourceOptions[0],
      shariah_stock_id: "",
      symbol: "",
      name: "",
      currency: currencyStockOptions[0],
      exchange: "NGX",
      sector: "",
      logo_url: "",
      offer_price: "",
      offer_open_date: dayjs(),
      offer_close_date: dayjs(),
      min_subscription_shares: 10,
      admin_fee_pct: 1.5,
      total_shares_on_offer: "",
      issuer: "",
      overview: "",
      highlights: "",
      key_information: "",
      risk_disclosure: "",
      prospectus_url: "",
      status: ipoCreateStatusOptions[0],
    },
    validationSchema: createIpoSchema,
    onSubmit: (values, { setSubmitting }) => {
      const data = buildIpoPayload(values);
      dispatch(createIpo({ data, navigate, setSubmitting }));
    },
  });

  return (
    <DashboardLayout>
      <div className="px-2 lg:px-8">
        <div className="flex items-center mb-8 flex-row md:items-center">
          <Link to={"/dashboard"}>
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-2" />
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
          <Link to="/ipos" className="font-semibold text-[#475467] text-base flex">
            IPOs
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 md:mr-2" />
          <span className="font-semibold text-[#475467] text-base bg-[#F9FAFB] p-1 rounded-md">
            Create
          </span>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center mt-8 mb-4 md:mb-6">
          <h1 className="font-semibold text-xl md:text-2xl w-full">
            List a New IPO
          </h1>
        </div>
        <BackArrow2 mb={20} ml={0} />

        <IpoForm
          form={form}
          loading={loading}
          submitLabel="Create IPO"
          onCancel={() => navigate(-1)}
        />
      </div>
    </DashboardLayout>
  );
}

export default CreateIpo;
